module.exports = __webpack_public_path__ + "static/media/newProductIlustration.90e621d5.svg";